<template>
  <div>
    <b-form-input
      type="date"
      :placeholder="placeholder"
      v-model="formattedValue"
      :readonly="readonly"
    >
    </b-form-input>
    <!-- <div>value is null? {{ value == null }}</div>
    <div>formattedValue is null? {{ formattedValue == null }}</div> -->
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";

export default {
  name: "BaseInputDate",
  props: {
    value: String,
    placeholder: String,
    readonly: Boolean,
  },
  directives: {
    mask: AwesomeMask,
  },
  data() {
    return {
      formattedValue: "",
    };
  },
  created() {
    this.formattedValue = this.dateToString(this.value);
  },
  computed: {},
  methods: {
    dateToString(value) {
      let strValue = value;
      return strValue;
    },
  },
  watch: {
    formattedValue() {
      let newValue = this.formattedValue;
      if (!newValue) newValue = null;
      if (newValue == "") newValue = null;
      this.$emit("update:value", newValue);
    },
    value() {
      this.formattedValue = this.dateToString(this.value);
      this.$forceUpdate();
    },
  },
};
</script>
